<template>
  <WellModalContent 
    class="pt-10"
    @close="$attrs._close()"
    size="small"
  >
    <form @submit.prevent="toggleFeaturedEventSubmit">
      <p class="mb-4">
        Are you sure you want to {{ props.event.is_www_featured ? 'unfeature' : 'feature' }} this event?
      </p>
      <button class="button-dark-outlined w-full" type="submit" :disabled="inProgress">
        {{ props.event.is_www_featured ? 'Unfeature event' : 'Feature event' }}
      </button>
    </form>
  </WellModalContent>
</template>

<script lang="ts" setup>
import WellModalContent from '~/components/common/WellModalContent.vue'
import { useApi } from '@/composables/useApi'

const { toggleFeaturedEvent } = useApi() 

const props = defineProps<{
  event: EventResponse,
}>()

const attrs = useAttrs()

const inProgress = ref(false)

const toggleFeaturedEventSubmit = async () => {
  try {
    inProgress.value = true
    await toggleFeaturedEvent(props.event.id)
    attrs._close()
  } catch (error) {
    console.error(error)
  } finally {
    inProgress.value = false
  }
}
</script>